import { defineAsyncComponent } from 'vue'
export default {
  "auth-page": defineAsyncComponent(() => import("/app/layouts/AuthPage.vue").then(m => m.default || m)),
  "rsvp-guest": defineAsyncComponent(() => import("/app/layouts/RsvpGuest.vue").then(m => m.default || m)),
  "side-bar-layout": defineAsyncComponent(() => import("/app/layouts/SideBarLayout.vue").then(m => m.default || m)),
  "side-bar-layout-for-feed-guest": defineAsyncComponent(() => import("/app/layouts/SideBarLayoutForFeedGuest.vue").then(m => m.default || m)),
  main: defineAsyncComponent(() => import("/app/layouts/main.vue").then(m => m.default || m))
}